<template>
  <div class="main-content sn-content">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="应用一览" name="appliList">

        <el-row style="marginBottom:15px;">
          <el-col :xs="12" :sm="24" justify="end">
            <!-- <router-link v-if="parseInt(userQuotaForAppli.quota) > parseInt(appliCnt) " :to="{path:'/appli/add'}"
                        style="color: #435465;float: right">
               添加应用
             </router-link>-->
            <router-link :to="{path:'/price/index',query: {from: 'appli'} }" class="pvt-color"
                         style="float: right">
              价格详情
            </router-link>
            <el-button v-if="userBalance > 0 && parseInt(userQuotaForAppli.split(',')[1]) > parseInt(appliCnt) " class="pvt-color" type="text" style="float: right;padding:3px ;marginRight:20px;"
                       @click="gotoAppliAdd()">
              添加应用
            </el-button>
            <router-link v-show="appliList.length > 0" :to="{path: '/appli/replaceLogo'}" class="pvt-color"
                         style="marginRight: 20px;float: right;">替换启动Logo
            </router-link>
          </el-col>
        </el-row>
        <el-tag v-if="userLeftZipFileSize < 0" type="danger" style="margin-bottom: 10px">温馨提示：您当前应用存储已超出配额，总计超出配额 {{
          (-userLeftZipFileSize) | transformByte}}，请删除不再使用的应用，删除后才可以正常进入应用，感谢支持。
        </el-tag>
        <el-table :data="appliList">
          <template slot="empty">
            <el-button v-if="userBalance > 0" @click="gotoAppliAdd()"
                       type="text"
                       size="small"
                       style="font-size:14px;"
                       class="pvt-color">添加托管应用
            </el-button>
          </template>
          <el-table-column
            prop="appliId"
            label="应用Id"
            width="200">
          </el-table-column>
          <el-table-column
            prop="appliName"
            label="应用名称">
          </el-table-column>
          <el-table-column
            label="应用大小">
            <template slot-scope="scope">
              <span> {{scope.row.fileSize | transformByte}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="计费模式">
            <template slot-scope="scope">
              <span v-if="scope.row.chargeType == 2"> 按量付费</span>
              <span v-if="scope.row.chargeType == 1"> 包月</span>
            </template>
          </el-table-column>
          <el-table-column
            label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status == 1"> 有效</span>
              <span class="danger" v-if="scope.row.status == 0"> 无效</span>
            </template>
          </el-table-column>
          <!--  <el-table-column
              prop="instanceMax"
              label="应用并发数">
            </el-table-column>-->
          <el-table-column
            label="应用类型">
            <template slot-scope="scope">
              <span v-if="scope.row.appliType=='1'">   独占 </span>
              <span v-if="scope.row.appliType=='2'">  3D共享 </span>
              <span v-if="scope.row.appliType=='14'">  2D共享 </span>
              <span v-if="scope.row.appliType=='3'">   VR(SteamVR) </span>
              <span v-if="scope.row.appliType=='5'">  VR(SteamVR:Need Steam) </span>
              <span v-if="scope.row.appliType=='7'">  VR(OpenXR) </span>
                <span v-if="scope.row.appliType=='16'">  webGL  </span>
              <span v-if="scope.row.appliType=='11'">   AR(Nvidia) </span>
            </template>
          </el-table-column>

          <el-table-column
            label="是否开启数据通道">
            <template slot-scope="scope">
              <span v-if="scope.row.dcs == '1'"> 是</span>
              <span v-if="scope.row.dcs == '0'"> 否</span>
            </template>
          </el-table-column>
          <el-table-column
            label="是否开启互动模式">
            <template slot-scope="scope">
              <span v-if="scope.row.playMode == '1'"> 是</span>
              <span v-if="scope.row.playMode == '0'"> 否</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="createDate"
            label="创建时间">
            <template slot-scope="scope">
              {{scope.row.createDate | formatDate}}
            </template>
          </el-table-column>
          <el-table-column
            label="操作" width="150px">
            <template slot-scope="scope">
              <div>
                <div v-if="scope.row.isWebGL == 0 && scope.row.syncingFlag != null && scope.row.syncingFlag" style="float: left">
                  <span>同步中<i class="el-icon-loading"></i></span>
                </div>
                <el-button v-else type="text"
                           class="pvt-color" style="position: relative;z-index: 999;"
                           @click="showTip(scope.row.appliId)">
                  进入
                </el-button>
                <!--<el-button type="text"
                           class="pvt-color" style="position: relative;z-index: 999;"
                           @click="showTip(scope.row.appliId)">
                  进入
                </el-button>-->
                <!--  <el-link type="primary" target="_blank" :href="$apiUrl+'/pocAppli/start?appliId='+scope.row.appliId">进入</el-link>-->
                <el-divider direction="vertical"></el-divider>
                <el-dropdown :hide-on-click="false" @command="handleCommand"
                             @visible-change="dropdownVisibleFn($event,scope.$index)">
              <span class="el-dropdown-link pointer ">
                更多<i class="el-icon-arrow-down el-icon--right pointer"></i>
              </span>
                  <el-dropdown-menu slot="dropdown">
                  <!--  <el-dropdown-item
                      v-if="(scope.row.appliType == 2 || scope.row.appliType == 14) && (scope.row.syncingFlag == null || !scope.row.syncingFlag)"
                      style="position:relative;" :command="{val:'qr',appliId:scope.row.appliId,index:scope.$index}">
                      <span>二维码</span>
                      <div v-if="scope.row.snVisible" style="position:absolute;left: -90px;top: 0;" class="qrcode"
                           :ref="'qrcodeContainer'+scope.$index"></div>
                    </el-dropdown-item>-->
                    <!--       <el-dropdown-item v-if="scope.row.syncingFlag == null || !scope.row.syncingFlag">-->
                    <el-dropdown-item>
                      <router-link
                        style="color: #333"
                        class="router-link-btn"
                        :to="{ path: '/appli/update', query: { appliId: scope.row.appliId,redirect:'/appli/index'}}">
                        编辑
                      </router-link>
                    </el-dropdown-item>

                    <el-dropdown-item>
                      <router-link
                        v-if="(scope.row.appliType == 2  && (scope.row.syncingFlag == null || !scope.row.syncingFlag)) || scope.row.appliType == 16 || scope.row.appliType == 14"
                        style="color: #333"
                        class="router-link-btn"
                        :to="{ path: '/appli/share',
                         query: { appliId: scope.row.appliId, appliName: scope.row.appliName, playMode:scope.row.playMode,redirect:'/appli/index',page:$refs.pageInfo.currentPage}}">
                        分享
                      </router-link>
                    </el-dropdown-item>
                 <!--   <el-dropdown-item v-if="scope.row.syncingFlag == null || !scope.row.syncingFlag">

                      <el-input :id="'url'+scope.row.appliId"
                                :value="$apiUrl+'/pocAppli/start?appliId='+scope.row.appliId"
                                style="position: absolute;opacity: 0;z-index: -1">
                      </el-input>
                      <el-button
                        v-if="(scope.row.appliType == 2 || scope.row.appliType == 14) && (scope.row.syncingFlag == null || !scope.row.syncingFlag)"
                        type="text" style="color: #333;position: relative;z-index: 999;"
                        @click="copyUrl(scope.row.appliId)">
                        复制链接
                      </el-button>
                    </el-dropdown-item>-->
                    <el-dropdown-item
                      v-if="(scope.row.syncingFlag == null || !scope.row.syncingFlag) && scope.row.status == 0 ">
                      <el-button type="text" style="color: #333;position: relative;z-index: 999;"
                                 @click="handleUpdateAppliStatus(scope.row.appliId,scope.row.userId,1)">
                        上架应用
                      </el-button>
                    </el-dropdown-item>
                    <el-dropdown-item
                      v-if="(scope.row.syncingFlag == null || !scope.row.syncingFlag) && scope.row.status == 1 ">
                      <el-button type="text" style="color: #333;position: relative;z-index: 999;"
                                 @click="handleUpdateAppliStatus(scope.row.appliId,scope.row.userId,0)">
                        下架应用
                      </el-button>
                    </el-dropdown-item>
                <!--    <el-dropdown-item
                      v-if="(scope.row.appliType == 2 || scope.row.appliType == 14) && (scope.row.syncingFlag == null || !scope.row.syncingFlag)">
                      <el-button :disabled="scope.row.playMode == '0'" type="text" style="color: #333"
                                 @click="openPlayerMode(scope.row.appliId)">互动模式
                      </el-button>
                    </el-dropdown-item>-->
                    <el-dropdown-item>
                      <el-button type="text" style="color: #333"
                                 @click="handleDelete(scope.row.appliId,scope.row.orderId)">删除
                      </el-button>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>

            </template>
          </el-table-column>

        </el-table>

        <el-row type="flex" justify="space-between" style="align-items: center;">
          <template v-if="$store.state.voucherBalance && $store.state.voucherBalance != ''">
            <p v-if="userBalance <= 0 && (!$store.state.voucherBalance>0)" class="balance-tip">
              {{appliList.length>0?"温馨提示：您的余额不足，应用即将被禁用，为了不影响您的使用，请及时充值。":"温馨提示：您的余额不足，为了不影响您的使用，请及时充值。"}}
              <router-link :to="{path:'/account/charge'}" style="color: #F56C6C;">
                【去充值】
              </router-link>
            </p>
            <div v-else></div>
          </template>
          <template v-else>
            <p v-if="userBalance <= 0" class="balance-tip">
              {{appliList.length>0?"温馨提示：您的余额不足，应用即将被禁用，为了不影响您的使用，请及时充值。":"温馨提示：您的余额不足，为了不影响您的使用，请及时充值。"}}
              <router-link :to="{path:'/account/charge'}" style="color: #F56C6C;">
                【去充值】
              </router-link>
            </p>
            <div v-else></div>
          </template>
          <PageComponent ref="pageInfo"></PageComponent>
        </el-row>

      </el-tab-pane>
      <el-tab-pane label="运行应用一览" name="runningAppliList">
        <el-button type="primary" style="float: left;margin-bottom: 10px" size="small" @click="closeMutTaskFn()"> 批量终止
        </el-button>
        <el-table :data="runningAppliList" @selection-change="handleSelectionChange" :row-key="getRowKeys">
          <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
          <el-table-column
            prop="appliId"
            label="应用Id">
          </el-table-column>
          <el-table-column
            prop="appliName"
            label="应用名称">
          </el-table-column>
          <el-table-column
            prop="clientIp"
            label="客户端Ip">
          </el-table-column>

          <el-table-column
            prop="startAt"
            label="开始时间">
            <template slot-scope="scope">
              {{scope.row.startAt | formatDateTime()}}
            </template>
          </el-table-column>
          <el-table-column
            label="操作" width="150px">
            <template slot-scope="scope">

              <el-button type="text" class="pvt-color" style="position: relative;z-index: 999;"
                         @click="closeTaskFn(scope.row.taskId)">
                终止
              </el-button>
            </template>
          </el-table-column>

        </el-table>
        <!--<PageComponent ref="runningApplipageInfo"></PageComponent>-->
      </el-tab-pane>

    </el-tabs>

    <el-dialog
      title="互动模式"
      :visible.sync="playerModeDialogVisible"
      custom-class="player-mode pxy-dialog"
      :close-on-click-modal="false"
      @close="clearplayerMode()"
      center>

      <el-form ref="form" :model="playerModeForm" label-width="80px" class="player-form">
        <!--模式-->
        <el-form-item label="模式">
          <el-radio-group v-model="playerModeForm.playerMode">
            <!--//互动模式-->
            <el-radio label="1"> 互动模式</el-radio>
            <!-- 协作模式-->
            <el-radio label="2">协作模式</el-radio>
          </el-radio-group>
        </el-form-item>
        <!--角色-->
        <el-form-item label="角色">
          <el-radio-group v-model="playerModeForm.role"
                          @change="userTypeChange($event)">
            <!--//演示模式-->
            <el-radio label="1">主控端</el-radio>
            <!-- 观看模式-->
            <el-radio label="0">从控端</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 昵称-->
        <el-form-item label="昵称">
          <el-input v-model="playerModeForm.nickname"></el-input>
        </el-form-item>
        <!--验证方式-->
        <el-form-item v-if="playerModeForm.role == '0'" label="验证方式">
          <el-radio-group v-model="playerModeForm.secretType">

            <!-- 口令模式-->
            <el-radio label="0" selected>口令</el-radio>
            <!--//任务Id-->
            <el-radio label="1">TaskId</el-radio>
          </el-radio-group>
        </el-form-item>
        <!--   口令-->
        <el-form-item
          :label="playerModeForm.secretType == '0'?'口令':'TaskId'">
        <span v-if="playerModeForm.role == '1'">
          <el-button type="primary" size="small" icon="el-icon-key" v-if="playerModeForm.roomCode == ''"
                     @click="createRoomCode()">生成口令</el-button>
    <el-input id="roomCode" readonly v-if="playerModeForm.roomCode != ''" v-model="playerModeForm.roomCode">
      <!--复制-->
          <el-button slot="append" @click="copyRoomCode()">复制</el-button>
  </el-input>

        </span>
          <el-input v-if="playerModeForm.role == '0' && playerModeForm.secretType == '0'"
                    v-model="playerModeForm.roomCode">
          </el-input>
          <el-input v-if="playerModeForm.role == '0' && playerModeForm.secretType == '1'"
                    v-model="playerModeForm.taskId">
          </el-input>
        </el-form-item>
        <el-form-item label="">
          <!-- <el-link type="primary" target="_blank" :href="$apiUrl+'/pocAppli/start?appliId='+playerModeForm.appliId+'&playerMode='+playerModeForm.playerMode+'&role='
           +playerModeForm.role+'&nickname='+playerModeForm.nickname+
           playerModeForm.secretType == '0' ? '&roomCode='+playerModeForm.roomCode : '&taskId='+playerModeForm.taskId">进入</el-link>-->
          <el-button type="primary" size="small" @click="enterAppliByPlayerMode()">
            生成
          </el-button>

        </el-form-item>
        <el-form-item label="链接：" style="display: none" id="playerModeUrlArea">
          <el-input id="playerModeUrl" v-model="playerModeForm.url">
            <el-button slot="append" @click="copyPlayerModeUrl()">复制</el-button>
          </el-input>
        </el-form-item>
      </el-form>
      <!--  </el-col>
      </el-row>-->
    </el-dialog>

  </div>
</template>

<script>
  import {Message} from "element-ui";
  import $ from "jquery"
  import PageComponent from '@/components/pageInfo/PageComponent'
  import QRCode from 'qrcodejs2';

  export default {
    components: {PageComponent},
    data() {
      return {
        playerModeDialogVisible: false,
        appliList: [],
        runningAppliList: [],
        appliCnt: 0,
        userQuotaForAppli: "",
        playerModeForm: {
          appliId: "",
          playerMode: "1",
          role: "1",
          nickname: '',
          roomCode: '',
          secretType: '0',
          taskId: '',
          url: ''
        },
        userLeftZipFileSize: 0,

        activeName: "appliList",
        mutTaskIds: []
      }
    },
    created() {
      if(window.location.search.indexOf('?utm_source=weixinsaoma')>-1) {
        window.location.search = '';
      }
    },
    computed: {
      user() {
        return this.$store.state.user;
      },
      userBalance() {
        console.log(this.$store.state.userBalance)
        console.log(this.$store.state.voucherBalance)
        return this.$store.state.userBalance;
      }
    },
    methods: {
      getAppliList: function () {
        var params = {};
        params.userId = this.$store.state.user.userId;
        params.page = this.$refs.pageInfo.currentPage;
        params.pageSize = 10;
        this.getRequest('/pocAppli/list', params).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.appliList = resp.data.result.records.map(item => {
                return Object.assign(item, {snVisible: false});//snVisible:控制更多操作中二维码的显示隐藏
              })
              this.appliCnt = resp.data.result.total;
              this.$refs.pageInfo.outputPagenator(resp.data.result.total, resp.data.result.pageSize);
              //TODO:查询poc_product表查询具体的配合信息
            } else {
              Message.error(resp.data.message);
            }
          }
        })
      },
      // 更多-下拉菜单隐藏时，把当前二维码图片隐藏掉
      dropdownVisibleFn(val, index) {
        if (val) {
          this.$set(this.appliList[index], 'snVisible', true);
        } else {
          this.$set(this.appliList[index], 'snVisible', false);
        }
      },
      getUserQuota: function () {
        this.getRequest('/uacUserConfig/getInfo', {"userId": this.$store.state.user.userId}).then(resp => {
          if (resp.status == 200) {
            if (resp.data.code == 1000) {
              this.userQuotaForAppli = resp.data.result.appliQuota;
            } else {
              Message.error(resp.data.message);
            }
          }
        })
      },
      gotoAppliAdd() {
        if (parseInt(this.userBalance) < 20) {
          this.$confirm('余额不足20，无法创建应用，请选择"去充值"。如果想获取额外支持，拨打热线电话：4006781024', '温馨提示', {
            confirmButtonText: '去充值',
            cancelButtonText: '关闭',
            type: 'warning',
            center: true
          }).then(() => {
            this.$router.push({path: '/account/charge'})
          }).catch(() => {

          });
        } else {
          this.$router.push({path: '/appli/add'})
        }

    },
    updateAppli(row) {
      var _this = this;
      var params = {};
      params.sn = row.sn;
      params.id = row.id;
      this.postRequestJson('/poc/cloudSn/reset', JSON.stringify(params)).then(resp => {
        _this.loading = false;
        if (resp && resp.status == 200) {
          var data = resp.data;
          if (data.code == 1000) {
            Message.success(data.message);
          } else {
            Message.error(data.message);
          }
        }
      });
    },
    copyUrl(appliId) {
      var id = "url" + appliId;
      let text = document.getElementById(id);
      text.select();
      document.execCommand('Copy');
      this.$message({type: 500, message: "复制成功"});
    },
    clearplayerMode: function () {
      this.playerModeForm = {
        playerMode: "1",
        role: "1",
        nickname: '',
        roomCode: '',
        taskId: '',
        secretType: '0',
        url: '',
      }
    },
    userTypeChange: function (event) {
      this.playerModeForm.role = event;
      this.playerModeForm.roomCode = '';
      this.playerModeForm.secretType = '0';
      this.playerModeForm.taskId = '';
    },
    createRoomCode: function () {
      this.getRequest("/pocAppli/getRoomCode", {}).then(resp => {
        if (resp && resp.status == 200) {
          if (resp.data.code == 1000) {
            console.log(resp.data.result)
            this.playerModeForm.roomCode = resp.data.result.roomCode;
          }
        }
      })

    },
    copyRoomCode: function () {
      let text = document.getElementById('roomCode');
      text.select();
      document.execCommand('Copy');
      this.$message({type: 500, message: "复制成功"});
    },
    copyPlayerModeUrl: function () {
      let text = document.getElementById('playerModeUrl');
      text.select();
      document.execCommand('Copy');
      this.$message({type: 500, message: "复制成功"});
    },
    openPlayerMode: function (appliId) {
      this.playerModeDialogVisible = true;
      this.playerModeForm.appliId = appliId;
    },
    enterAppliByPlayerMode: function () {
      var url = this.$apiUrl + "/pocAppli/start?appliId=" + this.playerModeForm.appliId;
      url += '&playerMode=' + this.playerModeForm.playerMode;
      url += '&role=' + this.playerModeForm.role;
      url += '&nickname=' + this.playerModeForm.nickname;
      if (this.playerModeForm.secretType == "0") {
        url += '&authCode=' + this.playerModeForm.roomCode;
      } else {
        url += '&taskId=' + this.playerModeForm.taskId;
      }

      $("#playerModeUrlArea").show();
      this.playerModeForm.url = url;
    },

    handleDelete(appliId, orderId) {
      var _this = this;
      _this.$confirm("确认删除？", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: 'warning'
      }).then(() => {
        _this.doDelete(appliId, orderId);
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: "取消"
        });
      });
    },
    doDelete(appliId, orderId) {
      this.postRequestJson("/pocAppli/delete", {"appliId": appliId}).then(resp => {
        if (resp && resp.status == 200) {
          var data = resp.data;
          this.getAppliList()
          this.$message({type: data.status, message: data.message});
        }
      });
    },

    handleUpdateAppliStatus(appliId, userId, status) {
        var msg = status == 1 ? "上架" : "下架"
      var _this = this;
      _this.$confirm("确认"+msg + "?", "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: 'warning'
      }).then(() => {
        _this.doUpdateAppliStatus(appliId, userId, status);
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: "取消"
        });
      });
    },
    doUpdateAppliStatus(appliId, userId, status) {
      this.postRequestJson("/poc/hostAppli/updateStatus", {
        "appliId": appliId,
        "userId": userId,
        "status": status
      }).then(resp => {
        if (resp && resp.status == 200) {
          var data = resp.data;
          this.getAppliList()
          this.$message({type: data.status, message: data.message});
        }
      });
    },
    showTip(appliId) {
      var that = this;
      this.$confirm('托管应用为按量计费模式；即:进入应用开始计费，退出应用结束计费；当使用结束时请关闭网页退出应用', '温馨提示', {
        confirmButtonText: '进入',
        cancelButtonText: '关闭',
        type: 'warning',
        center: true
      }).then(async () => {
        //判断应用是否是加密的
        var timestamp = new Date().getTime() + 15 * 60 * 1000;
        var tokenStr = "";
        await that.createSignature(appliId,timestamp).then(res1 => {
          if (res1 != undefined) {
             tokenStr = "&wsId=" + res1.wsId
              + "&timestamp=" + res1.timestamp + "&signature=" + res1.signature
          }
        })
        var url = that.$apiUrl + '/pocAppli/start?appliId=' + appliId + tokenStr;
        window.open(url)
      }).catch(() => {
      });
    },
      createSignature: function (appliId,timestamp) {
        return new Promise((resolve, reject) => {
          var params = {}
          params.appliId = appliId
          params.timestamp = timestamp
          this.getRequest("/pocAppli/getShareUrlSignature", params, {
            timeout: 0,
          }).then((res) => {
            if (res.data.code === 1000) {
              //当没有设置客户端密钥的时候，res.data.result为undefined
              resolve(res.data.result);
            } else {
              resolve('');
            }
          }).catch((err) => {
            console.log('mergeRequest -> err', err);
            reject();
          });
        });
      },
    handleCommand(command) {
      if (command) {
        const _this = this;
        if (command.val == 'qr') {
          _this.$nextTick(() => {
            _this.getWXEWM(command.appliId, command.index);
          })
        }
      }

    },
      handleClick:function (e) {
        if(this.activeName == "runningAppliList"){
          this.getRunningAppliList()
        }
      },
    getWXEWM(appliId, index) {
      $(".qrcode").html("");
      let qrCode = new QRCode(this.$refs['qrcodeContainer' + index], {
        width: 100,
        height: 100,
        colonDark: '#000',
        colonLight: '#fff',
        text: this.$apiUrl + '/pocAppli/start?appliId=' + appliId
      })
    },
    getLeftZipFileSize: function () {
      this.getRequest('/pocAppli/getLeftZipFileSize', {userId: this.$store.state.user.userId}).then(resp => {
        if (resp.status == 200) {
          if (resp.data.code == 1000) {
            this.userLeftZipFileSize = resp.data.result;
          } else {
            Message.error(resp.data.message);
          }
        }
      })
    },

    // 获取运行应用列表
    getRunningAppliList() {
      var params = {
        page: 1,
        pageSize: 100
      }
      this.getRequest("/pocAppli/getRunningList", params).then(resp => {
        if (resp.status == 200 && resp.data.code == 1000) {
          console.log("ssss", resp.data.result)
          this.runningAppliList = resp.data.result
        } else {
          this.$message({type: resp.data.code, message: resp.data.message});
        }
      })
    },
    // 终止任务
    closeTaskFn(id) {
      var taskIdList = [id];
      this.postRequestJson("/pocAppli/closeTask", JSON.stringify(taskIdList)).then(resp => {
        if (resp && resp.status == 200) {
          if (resp.data.code === 1000) {
            this.getRunningAppliList();
            this.$message.success('success');
          } else {
            this.$message({type: resp.data.code, message: resp.data.message});
          }
        }
      });
    },
    getRowKeys(row) {
      return row.taskId; // 每条数据的唯一识别值
    },
    // 勾选表格
    handleSelectionChange(val) {
      this.mutTaskIds = val;
    },
    //批量终止任务
    closeMutTaskFn() {
      if (this.mutTaskIds.length === 0) {
        /* '请勾选正在运行的任务！'*/
        this.$message.warning("请勾选正在运行的任务")
        return;
      }
      var taskIdList = this.mutTaskIds.map(item => {
        return item.taskId
      });
      this.postRequestJson("/pocAppli/closeTask", JSON.stringify(taskIdList)).then(resp => {
        if (resp && resp.status == 200) {
          if (resp.data.code === 1000) {
            this.getRunningAppliList();
            this.$message.success('success');
          } else {
            this.$message({type: resp.data.code, message: resp.data.message});
          }
        }
      });
    },
  }
  ,
  mounted: function () {
    this.getAppliList();
    this.getRunningAppliList();
    this.getUserQuota();
    this.$refs.pageInfo.initPagenator(this.getAppliList, null);
    /*  this.getRequest('/poc/hostAppli/getUrl', {appliId : '922512781213696000'}).then(resp => {
        console.log(resp)
      })*/
    this.getLeftZipFileSize()
  }
  ,
  beforeDestroy()
  {

  }
  }
</script>
<style>
  .pxy-dialog {
    min-width: 300px !important;
  }

  .player-form {
    padding: 0 20px 1px 0;
    box-sizing: border-box;
  }
</style>
